
import { Component, Vue } from "vue-property-decorator";
import { Logger } from "@/utils/Logger";
import { rulesForms } from "@/core/RulesForm";
import { authService } from "@/core/service/licencesnationales/AuthentificationService";
import { Message, MessageType } from "@/core/CommonDefinition";
import { LicencesNationalesBadRequestApiError } from "@/core/service/licencesnationales/exception/LicencesNationalesBadRequestApiError";
import MessageBox from "@/components/common/MessageBox.vue";

@Component({ components: { MessageBox } })
export default class ForgotPassword extends Vue {
  rulesForms: any = rulesForms;
  siren: string = "";
  isTokenValid: Promise<boolean> = this.$recaptchaLoaded();
  token: string = "";
  mail: string = "";
  sirenRadio: boolean = true;
  buttonLoading: boolean = false;

  async recaptcha() {
    await this.$recaptchaLoaded();
    this.token = await this.$recaptcha("forgotPassword");
    this.validate();
  }

  validate(): void {
    if (this.sirenRadio) {
      if (
        (this.$refs.formSIREN as Vue & { validate: () => boolean }).validate()
      ) {
        this.buttonLoading = true;
        this.$store.dispatch("closeDisplayedMessage");
        authService
          .motDePasseOublieSiren({
            siren: this.siren,
            recaptcha: this.token
          })
          .then(response => {
            const message: Message = new Message();
            message.type = MessageType.VALIDATION;
            message.texte = response.message;
            message.isSticky = true;
            this.$store.dispatch("openDisplayedMessage", message).catch(err => {
              Logger.error(err);
            });
            // On glisse sur le message d'erreur
            const messageBox = document.getElementById("messageBox");
            if (messageBox) {
              window.scrollTo(0, messageBox.offsetTop);
            }
          })
          .catch(err => {
            Logger.error(err.toString());
            const message: Message = new Message();
            message.type = MessageType.ERREUR;
            if (err instanceof LicencesNationalesBadRequestApiError) {
              message.texte = err.message;
            } else {
              message.texte = "Impossible d'exécuter l'action : " + err.message;
            }
            message.isSticky = true;

            this.$store.dispatch("openDisplayedMessage", message).catch(err => {
              Logger.error(err.toString());
            });
            // On glisse sur le message d'erreur
            const messageBox = document.getElementById("messageBox");
            if (messageBox) {
              window.scrollTo(0, messageBox.offsetTop);
            }
          })
          .finally(() => {
            this.buttonLoading = false;
          });
      }
    } else {
      if (
        (this.$refs.formMail as Vue & { validate: () => boolean }).validate()
      ) {
        this.buttonLoading = true;
        this.$store.dispatch("closeDisplayedMessage");
        authService
          .motDePasseOublieEmail({
            email: this.mail,
            recaptcha: this.token
          })
          .then(response => {
            const message: Message = new Message();
            message.type = MessageType.VALIDATION;
            message.texte = response.message;
            message.isSticky = true;
            this.$store.dispatch("openDisplayedMessage", message).catch(err => {
              Logger.error(err);
            });
            // On glisse sur le message d'erreur
            const messageBox = document.getElementById("messageBox");
            if (messageBox) {
              window.scrollTo(0, messageBox.offsetTop);
            }
          })
          .catch(err => {
            Logger.error(err.toString());
            const message: Message = new Message();
            message.type = MessageType.ERREUR;
            if (err instanceof LicencesNationalesBadRequestApiError) {
              message.type = MessageType.VALIDATION;
              message.texte =
                "Si l'adresse e-mail est reconnue, vous recevrez un lien de réinitialisation du mot de passe";
            } else {
              message.texte = "Impossible d'exécuter l'action : " + err.message;
            }
            message.isSticky = true;

            this.$store.dispatch("openDisplayedMessage", message).catch(err => {
              Logger.error(err.toString());
            });
            // On glisse sur le message d'erreur
            const messageBox = document.getElementById("messageBox");
            if (messageBox) {
              window.scrollTo(0, messageBox.offsetTop);
            }
          })
          .finally(() => {
            this.buttonLoading = false;
          });
      }
    }
  }
}
